import { checkApiResponse, put } from "../services/webClient";
import { configurations } from "../configurations";

export const registerPayment = (payload) =>
    put(configurations.apiUrl + "/payments", payload)
        .then(checkApiResponse);